import { defineStore } from 'pinia';

import * as state from './inbox.state';
import * as getters from './inbox.getters';
import * as actions from './inbox.actions';

export const useInboxStore = defineStore('inbox', () => ({
  ...state,
  ...getters,
  ...actions
}));
